// extracted by mini-css-extract-plugin
module.exports = {"bigEnergyTarget":"EnergyTarget_bigEnergyTarget__1vEFL"};